import * as Sentry from '@sentry/browser';
if (process.env.SENTRY_DSN) {
    const sentryConfig = { dsn: process.env.SENTRY_DSN };
    if (process.env.SENTRY_RELEASE) {
        sentryConfig.release = process.env.SENTRY_RELEASE;
    }
    Sentry.init(sentryConfig);
}
import('./App.svelte').then(({ default: App }) => new App({ target: document.body }));
